import type { Currency } from '../../../../generated-types';

export enum FilterModalType {
    CATEGORY,
    DATERANGE,
    AMOUNTRANGE,
    NONE,
}

export type TransactionModalContentProps = {
    targetCurrency: Currency;
};
